import { AbstractControl } from '@angular/forms';

export class UserCreationValidators {
    static usernameEndWithInterapt(control: AbstractControl) {
        if (control.value && control.value.endsWith('@interapt')) return null;
        return {usernameEndWithInterapt: true};
    }

    static emailEndWithInterapt(control: AbstractControl) {
        if (control.value && control.value.endsWith('@interapt.com')) return null;
        return {emailEndWithInterapt: true};
    }

    static mustBeEmail(control: AbstractControl) {
        let patternUrl = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i
        if(control.value && patternUrl.test(control.value)) return null;
        return {mustBeEmail: true};
    }
}


// WEBPACK FOOTER //
// /app/src/app/validators/user-create/user-creation-validators.ts